import React from 'react';
import { Navigate } from 'react-router-dom';
import { usePortalAuth } from '../context/PortalAuthContext';

interface Props {
  children: React.ReactNode;
  requireSuperAdmin?: boolean;
}

export const PortalProtectedRoute: React.FC<Props> = ({ children, requireSuperAdmin = false }) => {
  const { stage, admin, loading } = usePortalAuth();

  if (loading) {
    return <div className="portal-loading">Loading...</div>;
  }

  if (stage !== 'fully_authenticated') {
    return <Navigate to="/ip-portal/login" replace />;
  }

  if (requireSuperAdmin && admin?.role !== 'super_admin') {
    return <Navigate to="/ip-portal/dashboard" replace />;
  }

  return <>{children}</>;
};
